/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetPayorsParams,
  HTTPValidationError,
  PagePayorRead,
  PayorCreate,
  PayorRead,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new payor.
 * @summary Create Payor
 */
export const createPayor = (payorCreate: PayorCreate, signal?: AbortSignal) => {
  return customInstance<PayorRead>({
    url: `/api/payor/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: payorCreate,
    signal,
  });
};

export const getCreatePayorMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPayor>>,
    TError,
    { data: PayorCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPayor>>,
  TError,
  { data: PayorCreate },
  TContext
> => {
  const mutationKey = ["createPayor"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPayor>>,
    { data: PayorCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createPayor(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePayorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPayor>>
>;
export type CreatePayorMutationBody = PayorCreate;
export type CreatePayorMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Payor
 */
export const useCreatePayor = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPayor>>,
      TError,
      { data: PayorCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPayor>>,
  TError,
  { data: PayorCreate },
  TContext
> => {
  const mutationOptions = getCreatePayorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many payors.

Results are paginated.
 * @summary Get Payors
 */
export const getPayors = (params?: GetPayorsParams, signal?: AbortSignal) => {
  return customInstance<PagePayorRead>({
    url: `/api/payor/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPayorsInfiniteQueryKey = (params?: GetPayorsParams) => {
  return ["infinite", "api", "payor", ...(params ? [params] : [])] as const;
};

export const getGetPayorsQueryKey = (params?: GetPayorsParams) => {
  return ["api", "payor", ...(params ? [params] : [])] as const;
};

export const getGetPayorsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPayors>>,
    GetPayorsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPayorsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPayors>>,
        TError,
        TData,
        QueryKey,
        GetPayorsParams["page"]
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPayorsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPayors>>,
    QueryKey,
    GetPayorsParams["page"]
  > = ({ signal, pageParam }) =>
    getPayors({ ...params, page: pageParam || params?.["page"] }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPayors>>,
    TError,
    TData,
    QueryKey,
    GetPayorsParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPayorsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayors>>
>;
export type GetPayorsInfiniteQueryError = ErrorType<void | HTTPValidationError>;

export function useGetPayorsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPayors>>,
    GetPayorsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetPayorsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPayors>>,
        TError,
        TData,
        QueryKey,
        GetPayorsParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayors>>,
          TError,
          Awaited<ReturnType<typeof getPayors>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPayorsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPayors>>,
    GetPayorsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPayorsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPayors>>,
        TError,
        TData,
        QueryKey,
        GetPayorsParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayors>>,
          TError,
          Awaited<ReturnType<typeof getPayors>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPayorsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPayors>>,
    GetPayorsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPayorsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPayors>>,
        TError,
        TData,
        QueryKey,
        GetPayorsParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Payors
 */

export function useGetPayorsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getPayors>>,
    GetPayorsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPayorsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPayors>>,
        TError,
        TData,
        QueryKey,
        GetPayorsParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPayorsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPayorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPayorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPayors>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPayorsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayors>>> = ({
    signal,
  }) => getPayors(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPayors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPayorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayors>>
>;
export type GetPayorsQueryError = ErrorType<void | HTTPValidationError>;

export function useGetPayors<
  TData = Awaited<ReturnType<typeof getPayors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetPayorsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPayors>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayors>>,
          TError,
          Awaited<ReturnType<typeof getPayors>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPayors<
  TData = Awaited<ReturnType<typeof getPayors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPayorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPayors>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayors>>,
          TError,
          Awaited<ReturnType<typeof getPayors>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPayors<
  TData = Awaited<ReturnType<typeof getPayors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPayorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPayors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Payors
 */

export function useGetPayors<
  TData = Awaited<ReturnType<typeof getPayors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetPayorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPayors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPayorsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an payor by ID.
 * @summary Get Payor
 */
export const getPayor = (payorId: number, signal?: AbortSignal) => {
  return customInstance<PayorRead>({
    url: `/api/payor/${payorId}`,
    method: "GET",
    signal,
  });
};

export const getGetPayorQueryKey = (payorId?: number) => {
  return ["api", "payor", payorId] as const;
};

export const getGetPayorQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  payorId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPayor>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPayorQueryKey(payorId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayor>>> = ({
    signal,
  }) => getPayor(payorId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!payorId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPayor>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetPayorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayor>>
>;
export type GetPayorQueryError = ErrorType<void | HTTPValidationError>;

export function useGetPayor<
  TData = Awaited<ReturnType<typeof getPayor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  payorId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPayor>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayor>>,
          TError,
          Awaited<ReturnType<typeof getPayor>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPayor<
  TData = Awaited<ReturnType<typeof getPayor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  payorId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPayor>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayor>>,
          TError,
          Awaited<ReturnType<typeof getPayor>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPayor<
  TData = Awaited<ReturnType<typeof getPayor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  payorId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPayor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Payor
 */

export function useGetPayor<
  TData = Awaited<ReturnType<typeof getPayor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  payorId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPayor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPayorQueryOptions(payorId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an payor by ID.
 * @summary Update Payor
 */
export const updatePayor = (payorId: number, payorCreate: PayorCreate) => {
  return customInstance<PayorRead>({
    url: `/api/payor/${payorId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: payorCreate,
  });
};

export const getUpdatePayorMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePayor>>,
    TError,
    { payorId: number; data: PayorCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePayor>>,
  TError,
  { payorId: number; data: PayorCreate },
  TContext
> => {
  const mutationKey = ["updatePayor"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePayor>>,
    { payorId: number; data: PayorCreate }
  > = (props) => {
    const { payorId, data } = props ?? {};

    return updatePayor(payorId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePayorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePayor>>
>;
export type UpdatePayorMutationBody = PayorCreate;
export type UpdatePayorMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Payor
 */
export const useUpdatePayor = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePayor>>,
      TError,
      { payorId: number; data: PayorCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePayor>>,
  TError,
  { payorId: number; data: PayorCreate },
  TContext
> => {
  const mutationOptions = getUpdatePayorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete an payor by ID.
 * @summary Delete Payor
 */
export const deletePayor = (payorId: number) => {
  return customInstance<unknown>({
    url: `/api/payor/${payorId}`,
    method: "DELETE",
  });
};

export const getDeletePayorMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePayor>>,
    TError,
    { payorId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePayor>>,
  TError,
  { payorId: number },
  TContext
> => {
  const mutationKey = ["deletePayor"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePayor>>,
    { payorId: number }
  > = (props) => {
    const { payorId } = props ?? {};

    return deletePayor(payorId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePayorMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePayor>>
>;

export type DeletePayorMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Payor
 */
export const useDeletePayor = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePayor>>,
      TError,
      { payorId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deletePayor>>,
  TError,
  { payorId: number },
  TContext
> => {
  const mutationOptions = getDeletePayorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
